import React, { useState } from 'react';
import styles from './SideBar.module.scss';
import { Link } from 'react-router-dom';
import { navigateTop, userInitials } from 'common/utils';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { SessionState, logoutUser } from 'features/session/sessionSlice';
import { cleanNextSteps, cleanFavorites } from 'features/user/userSlice';

const SideBarInitialsButton = () => {
  const { user } = useAppSelector(({ session }: { session: SessionState }) => session);
  const [active, setActive] = useState(false);
  const dispatch = useAppDispatch();

  const logout = () => {
    dispatch(logoutUser());
    navigateTop();
    dispatch(cleanFavorites());
    dispatch(cleanNextSteps());
  };
  return (
    <div
      className={styles.sidebarInitialsButton}
      onMouseOver={() => {
        setActive(true);
      }}
      onMouseOut={() => {
        setActive(false);
      }}
    >
      <div
        className={`ua-user-toggle ua-user btn rounded-circle bg-ua-light fw-bold p-1 d-flex align-items-center justify-content-center ${
          active ? 'active' : ''
        } `}
        onMouseOver={() => {
          setActive(true);
        }}
      >
        {userInitials(user)}
      </div>
      <div
        className={`nav-dropdown animate__animated animate__fadeIn animate__faster ${
          active ? 'end-0 top-md-100 d-flex' : 'd-none'
        }`}
      >
        <div className="bg-white rounded-2 d-flex flex-row">
          <ul className="list-unstyled nav-dropdown-main-list d-flex flex-column">
            <li>
              <Link className="link-unstyled hover-ua-color" to="/home/account_settings">
                <i className="bi bi-gear me-3" />
                Account settings
              </Link>
            </li>
            <li>
              <Link className="link-unstyled hover-ua-color" onClick={logout} to="/">
                <i className="bi bi-box-arrow-right me-3" />
                Logout
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SideBarInitialsButton;
